// extracted by mini-css-extract-plugin
export var dropdownButton = "_1u-0";
export var fullWidthDropdownButton = "_1u-1";
export var icon = "_1u-3";
export var iconPlaceholder = "_1u-2";
export var menuItemRow = "_1u-5";
export var shortcutContainer = "_1u-4";